import { apiSlice } from "./apiSlice";
import { authApi } from "./authApi";
import { cartApi } from "./cartApi";
import { eventApi } from "./eventApi";
import { filterApi } from "./filterApi";
import { profileApi } from "./profileApi";

export const apiReducers = {
  [apiSlice.reducerPath]: apiSlice.reducer,
  [filterApi.reducerPath]: filterApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [eventApi.reducerPath]: eventApi.reducer,
};

export const apiMiddleware = [
  apiSlice.middleware,
  filterApi.middleware,
  authApi.middleware,
  cartApi.middleware,
  eventApi.middleware,
  profileApi.middleware,
];
